import React from 'react';

import { SmartCreateStore, type SmartState } from './SmartCreateStore';

export const useSmartStore = (): SmartState => {
	const store = SmartCreateStore.getInstance();
	const [state, setState] = React.useState(store.getState());

	React.useEffect(() => {
		const subscriber = (newState: SmartState) => {
			setState({ ...newState, contentTypes: [...newState.contentTypes] });
		};
		store.subscribe(subscriber);

		return () => {
			store.unsubscribe(subscriber);
		};
	}, [store]);

	return state;
};
